import { render, staticRenderFns } from "./DirectorRoom.vue?vue&type=template&id=0aebae67&"
import script from "./DirectorRoom.vue?vue&type=script&lang=js&"
export * from "./DirectorRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports